import React, { useState } from "react";

function SantaClaraFAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const isActive = (index) => activeIndex === index;

  const faqs = [
    {
      question: "What areas do you serve in Santa Clara, CA?",
      answer:
        "We proudly serve Santa Clara, CA, and surrounding areas, including Mountain View, Palo Alto, Menlo Park, San Jose, Redwood City, and other cities in Santa Clara County.",
    },
    {
      question: "What types of junk do you remove?",
      answer:
        "We remove a wide variety of items, including furniture, appliances, mattresses, construction debris, yard waste, electronics, hot tubs, and more. No job is too big or small!",
    },
    {
      question: "Do you offer same-day service?",
      answer:
        "Yes, we provide same-day junk removal services for your convenience. Contact us to check availability and schedule your pickup.",
    },
    {
      question: "Are your disposal methods eco-friendly?",
      answer:
        "Absolutely! We prioritize eco-friendly disposal practices, including recycling and donating usable items to minimize environmental impact.",
    },
    {
      question: "Do you provide free estimates?",
      answer:
        "Yes, we offer free, no-obligation estimates. You can get a quote over the phone or request an onsite estimate with no hidden fees.",
    },
    {
      question: "How does pricing work?",
      answer:
        "Our pricing is transparent and based on the volume of junk you need removed. We provide upfront pricing so you know exactly what to expect.",
    },
    {
      question: "Can you handle large cleanouts?",
      answer:
        "Yes, we specialize in large cleanouts for homes, offices, estates, and construction sites. Whether it’s a single item or a full-scale project, we’ve got you covered.",
    },
    {
      question: "Do you remove heavy items like hot tubs or appliances?",
      answer:
        "Yes, our team is equipped to handle heavy items like hot tubs, refrigerators, washers, dryers, and more. We take care of the heavy lifting for you.",
    },
    {
      question: "Do you recycle electronics?",
      answer:
        "Yes, we provide responsible e-waste disposal services for old electronics, computers, televisions, and other electronic devices.",
    },
    {
      question: "Can you remove yard waste?",
      answer:
        "Yes, we offer yard waste removal services, including leaves, branches, and other green waste.",
    },
    {
      question: "Do you offer construction debris removal?",
      answer:
        "Yes, we provide construction debris removal services for renovation projects, construction sites, and home cleanouts.",
    },
    {
      question: "Are you licensed and insured?",
      answer:
        "Yes, Junk Droid is fully licensed and insured, ensuring a safe and professional experience for all our customers.",
    },
    {
      question: "Can you help with storage unit cleanouts?",
      answer:
        "Yes, we specialize in storage unit cleanouts, making the process seamless and stress-free for our clients.",
    },
    {
      question: "Do you offer flexible scheduling?",
      answer:
        "Yes, we work around your schedule to provide convenient same-day or next-day pickups.",
    },
    {
      question: "What sets Junk Droid apart from other junk removal services?",
      answer:
        "We pride ourselves on affordable pricing, eco-friendly practices, and exceptional customer service. Our experienced team ensures a hassle-free experience from start to finish.",
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion junk-faq-sec">
          {faqs.map((faq, index) => (
            <div
              className={`accordion-item ${isActive(index) ? "active" : ""}`}
              key={index}
            >
              <div
                className="accordion-item-header"
                onClick={() => handleAccordionClick(index)}
                style={{ color: isActive(index) ? "blue" : "#000" }}
              >
                <span className="accordion-item-header-title">
                  <img
                    src={
                      isActive(index)
                        ? "/assets/img/question-mark-yellow.svg"
                        : "/assets/img/_Compound Path_.png"
                    }
                    alt="default"
                    loading="lazy"
                    className="accordion-image"
                  />
                  <p>{faq.question}</p>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    style={{ color: isActive(index) ? "#2d6bd6" : "#000" }}
                  />
                </svg>
              </div>
              <div
                className={`accordion-item-description-wrapper ${
                  isActive(index) ? "open" : ""
                }`}
                style={{ display: isActive(index) ? "block" : "none" }}
              >
                <div className="accordion-item-description">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default SantaClaraFAQs;
